import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";

import { usePostUserForgot } from "../../../api/userDetails";
import { successMessage } from "../../../helpers/ErrorHandler";
import { AUTH_ROUTES } from "../constants/auth.constants";
import { buildPasswordResetState } from "../helpers/passwordResetRoute";
import { ForgotPasswordFormValues } from "../types/authForms.types";

/**
 * Form state for `ForgotPasswordNew`. Mirrors the legacy `PasswordForgot`
 * flow: `POST auth/forget-password`, then on success go to `/password-reset`
 * with `isPasswordResetRequired: true` — but now with the submitted email
 * prefilled, instead of the legacy screen's empty string.
 */
export const useForgotPasswordViewModel = () => {
  const navigate = useNavigate();
  const methods = useForm<ForgotPasswordFormValues>({ defaultValues: { email: "" } });

  const { mutate, isLoading: isPending } = usePostUserForgot();

  const onSubmit = methods.handleSubmit(values => {
    mutate(values, {
      onSuccess: () => {
        successMessage("Temporary password sent to your email");
        navigate(AUTH_ROUTES.resetPassword, {
          state: buildPasswordResetState(true, values.email)
        });
      }
    });
  });

  return {
    methods,
    onSubmit,
    isPending
  };
};
